import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const opportunityService = {
  getQuotationPdf,
  getAll,
  getPipeline,
  getStats,
  get,
  create,
  update,
  remove,
  setStage,
  markWon,
  markLost,
}

export function getAll(filter = {}) {
  const params = {}
  if (filter.page) params.page = filter.page
  if (filter.size) params.size = filter.size
  if (filter.search) params.search = filter.search
  if (filter.stage) params.stage = filter.stage
  if (filter.assignedTo) params.assigned_to = filter.assignedTo
  if (filter.debtorCode) params.debtor_code = filter.debtorCode
  if (filter.leadUuid) params.lead_uuid = filter.leadUuid
  return apiHelper(API_URL).get('/opportunities', { params })
}

/** Neglect counters shown above the deals list. */
export function getStats() {
  return apiHelper(API_URL).get('/opportunities/stats')
}

export function getPipeline() {
  return apiHelper(API_URL).get('/opportunities/pipeline')
}

export function get(uuid) {
  return apiHelper(API_URL).get(`/opportunities/${uuid}`)
}

export function create(payload) {
  return apiHelper(API_URL).post('/opportunities', payload)
}

export function update(uuid, payload) {
  return apiHelper(API_URL).put(`/opportunities/${uuid}`, payload)
}

export function remove(uuid) {
  return apiHelper(API_URL).delete(`/opportunities/${uuid}`)
}

export function setStage(uuid, stage) {
  return apiHelper(API_URL).patch(`/opportunities/${uuid}/stage`, { stage })
}

export function markWon(uuid, payload = {}) {
  return apiHelper(API_URL).patch(`/opportunities/${uuid}/won`, payload)
}

export function markLost(uuid, payload) {
  return apiHelper(API_URL).patch(`/opportunities/${uuid}/lost`, payload)
}

export function getQuotationPdf(uuid) {
  return apiHelper(API_URL).get(`/opportunities/${uuid}/quotation-pdf`, { responseType: 'blob' })
}
